export var PageType;
(function (PageType) {
    PageType["HOME_PAGE"] = "home_page";
    PageType["NEWS_PAGE"] = "news_page";
    PageType["PRODUCT_PAGE"] = "product_page";
    PageType["ABOUT_PAGE"] = "about_page";
    PageType["SERVICE_PAGE"] = "service_page";
    PageType["CONTACT_PAGE"] = "contact_page";
    PageType["REVIEWS_PAGE"] = "reviews_page";
    PageType["TICKET_PRICING_PAGE"] = "ticket_pricing_page";
    PageType["COMMON"] = "common";
})(PageType || (PageType = {}));
//# sourceMappingURL=page-type.js.map